'use client';
/* Built In Imports */
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useRef, useState } from 'react';

/* External Imports */
import {
  ChevronDownIcon,
  ChevronRightIcon,
  HamburgerIcon,
} from '@chakra-ui/icons';
import { Link } from '@chakra-ui/next-js';
import {
  Box,
  Button,
  Flex,
  Heading,
  HStack,
  Icon,
  Image,
  Input,
  List,
  ListItem,
  Portal,
  Show,
  SimpleGrid,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import forEach from 'lodash/forEach';
import { FaRegCheckCircle } from 'react-icons/fa';
import { GoCalendar } from 'react-icons/go';
import { useMediaQuery } from 'react-responsive';

/* Internal Imports */
/* Component */
import MobMenu from '@app-ps/Components/Header/MobMenu';
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';

/* Styles */
/* Services */
import { fetchMenuItem } from 'services/projSamskritiService';

/**
 * Renders Header Component
 * @param {Obj} headerMenuData
 * @param {Str} region
 * @param {Str} language
 * @returns {ReactElement} Header
 */
const Header = ({
  headerMenuData,
  region,
  language,
  // theme,
  headerMenuDataCopy,
}) => {
  // console.log(headerMenuData, 'header data');
  const [isPathChanged, setIsPathChanged] = useState(false);
  const [headerData, setHeaderData] = useState(headerMenuData?.allIsoMainMenus);
  const engage = headerData?.find(el => el?.key === 'hollow-btn');
  const calender = headerData?.find(el => el?.key === 'calender');
  const [activeInput, setActiveInput] = useState(false);
  const [mIndex, setMIndex] = useState(-1);
  const [menuLoaded, setMenuLoaded] = useState(false);
  const pathName = usePathname();
  const router = useRouter();
  const [showPrograms, setShowPrograms] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 960 });
  const ref = useRef(null);
  const [inputValue, setInputValue] = useState(null);
  const searchParams = useSearchParams();

  // console.log('headerMenuData', headerMenuData);
  const [isMegaMenu, setIsMegaMenu] = useState(-1);
  const callMenuData = async id => {
    setHeaderData(headerMenuDataCopy?.allIsoMainMenus);
    const menuData = await fetchMenuItem(id);
    setMenuLoaded(true);
    const newHeaderData = headerMenuDataCopy?.allIsoMainMenus;

    forEach(newHeaderData, function (menuItem) {
      if (menuItem?.key === 'productions') {
        // console.log('menuData', menuItem);
        forEach(menuItem?.submenuItems, function (subItem) {
          if (menuData[subItem?.key]) {
            let newMenuList = formatMenuData(menuData[subItem?.key]);
            subItem.submenuItems = newMenuList.concat(subItem.submenuItems);
          }
        });
      }
    });
    setHeaderData(newHeaderData);
  };

  const formatMenuData = menuList => {
    let newMenuList = [];
    forEach(menuList, function (menuItem) {
      newMenuList.push({
        icon: 'https://static.sadhguru.org/d/46272/1724171770-ticket-admit-vip.png',
        iconHover: '',
        title: menuItem.title,
        type: 'upcoming',
        url: `productions/upcoming?id=${menuItem.program_id}`,
      });
    });
    return newMenuList;
  };

  useEffect(() => {
    document.body.style.overflow = showPrograms && isMobile ? 'hidden' : 'auto';
    // setTimeout(function () {
    // }, 1500);
  }, [showPrograms]);

  useEffect(() => {
    callMenuData();
  }, [headerMenuDataCopy]);

  useEffect(() => {
    setShowPrograms(false);
    setIsMegaMenu(-1);
    // let i = 0;
    // console.log(i++)
    setIsPathChanged(true);
    // console.log(isPathChanged, "isPathChanged");
    setTimeout(() => {
      setIsPathChanged(false); // for fallback conditions
    }, 1000);
    return () => setIsPathChanged(true);
  }, [pathName, searchParams]);

  const { isOpen } = useDisclosure();
  const theme = 'light';
  const position = pathName === '/project-samskriti' ? 'absolute' : 'relative';

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }, [isOpen]);

  const goToSearch = () => {
    router.push(`/project-samskriti/search?q=${ref.current.value}`, {
      scroll: false,
    });
  };

  // console.log(headerData, "headerdata")
  return headerData?.length > 0 ? (
    <Box
      pb={{ base: '8px', md: '22px' }}
      width={'100%'}
      maxH={{ lg: '100px' }}
      pt={{ base: '24px', md: '22px' }}
      // height={{ base: '96px', md: '100%' }}
      height={{ base: '96px', md: '100%' }}
      px={{
        base: '1rem',
        md: '3%',
        lg: '5%',
        '2xl': '12%',
      }}
      pos={position}
      pr={{
        base: '5%',
        md: '3%',
        lg: '5%',
      }}
      bg={theme === 'light' ? 'rgba(0, 0, 0, 0.30)' : '#010509'}
      id="ps-header"
      // pos="relative"
      zIndex={100}
    >
      <Box
        className="desktopMenu"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        w="full"
        maxW={{ base: 'container.xl', lg: '95%', xl: 'full' }}
        mx="auto"
      >
        <Link
          href={refineUrlDomain('/', region, language)}
          _hover={{ textDecor: 'none', color: '#60ADFF' }}
          _focus={{ boxShadow: 'none' }}
          pl={{ base: '10px', md: 0 }}
          pos="relative"
          visibility={{
            base: activeInput ? 'hidden' : 'visible',
            md: 'visible',
          }}
          zIndex="5"
          prefetch
        >
          <Image
            src={`${config.imgPath}/d/46272/1718187194-frame-536.png`}
            width={118}
            // height={94}
            alt="logo"
            priority="true"
            maxW={182}
          />
        </Link>
        <Show above="lg">
          <nav>
            <ul className="container ul-reset">
              {headerData?.map((menu, key) => {
                if (
                  menu.key === 'logo' ||
                  menu.key === 'search' ||
                  menu.key === 'calender' ||
                  menu.key === 'hollow-btn' ||
                  menu.key === 'blog'
                ) {
                  return null;
                } else if (menu.submenuItems.length > 0) {
                  return (
                    <li
                      className="droppable"
                      key={key}
                      onMouseEnter={() => setIsMegaMenu(key)}
                      onMouseLeave={() => setIsMegaMenu(-1)}
                    >
                      <Text
                        fontSize="1rem"
                        fontFamily="var(--FedraSansStd-medium)"
                        textTransform="uppercase"
                        color="#FEFAF6"
                      >
                        <Link
                          href={refineUrlDomain(menu.url)}
                          _focus={{ boxShadow: 'none' }}
                          prefetch
                        >
                          {' '}
                          {menu.title} <ChevronDownIcon w={6} h={6} />
                        </Link>
                      </Text>

                      <Box
                        className="mega-menu"
                        px="1rem"
                        height="100vh"
                        // overflow="hidden"
                      >
                        <Box maxW="container.xl" mx="auto" height="100%">
                          <Flex className="container cf" height="100%">
                            {menu.submenuItems.map((sub, key1) => {
                              const engage = menu?.submenuItems?.find(
                                el => el.key === 'hollow-btn'
                              );
                              if (sub.key === 'explore-menu') {
                                return (
                                  <Box flex={1} w="302px" key={key1}>
                                    <Heading
                                      fontFamily="var(--FedraSansStd-medium)"
                                      fontSize="1rem"
                                      color="#FEFAF6"
                                      fontWeight="normal"
                                    >
                                      {sub.title}
                                    </Heading>
                                    <StructuredTextParser
                                      p="0"
                                      str={render(sub.body)}
                                      mb="1.5rem"
                                      fontFamily="var(--FedraSansStd-book)"
                                      color="#fff7e9"
                                    />
                                    <Link
                                      href={refineUrlDomain(sub?.url)}
                                      textDecor="none"
                                      _focus={{ boxShadow: 'none' }}
                                      prefetch
                                    >
                                      <Button
                                        fontFamily="var(--FedraSansStd-medium)"
                                        border="0px solid"
                                        background="#60ADFF"
                                        rounded="0"
                                        w={{ base: '200px', xl: '302px' }}
                                        fontWeight="normal"
                                        _focus={{ boxShadow: 'none' }}
                                      >
                                        {sub.subtext}
                                      </Button>
                                    </Link>
                                    {engage && (
                                      <Link
                                        href={refineUrlDomain(engage?.url)}
                                        textDecor="none"
                                        _focus={{ boxShadow: 'none' }}
                                        prefetch
                                      >
                                        <Button
                                          fontFamily="var(--FedraSansStd-medium)"
                                          border="0px solid"
                                          background="rgba(96, 173, 255, 0.10)"
                                          color="#60ADFF"
                                          rounded="0"
                                          mt="1.6rem"
                                          w={{ base: '200px', xl: '302px' }}
                                          fontWeight="normal"
                                          _focus={{ boxShadow: 'none' }}
                                          leftIcon={
                                            <FaRegCheckCircle size={24} />
                                          }
                                        >
                                          {engage?.title}
                                        </Button>
                                      </Link>
                                    )}
                                  </Box>
                                );
                              } else if (sub.key === 'hollow-btn') {
                                return;
                              }
                              return (
                                <List
                                  flex={1}
                                  className="ul-reset"
                                  key={key1}
                                  maxH="100%"
                                  overflow="hidden"
                                  h="auto"
                                >
                                  <SimpleGrid pos="relative" h="100%">
                                    <Box
                                      h="auto"
                                      maxH="100%"
                                      overflow="hidden"
                                      pos="relative"
                                    >
                                      <Box
                                        maxH="25%"
                                        h="auto"
                                        overflow="hidden"
                                      >
                                        <Text
                                          fontSize="1rem"
                                          color="#60ADFF"
                                          fontFamily="var(--FedraSansStd-medium)"
                                          display="flex"
                                          alignItems="center"
                                        >
                                          <Link
                                            href={refineUrlDomain(sub?.url)}
                                            _focus={{ boxShadow: 'none' }}
                                            prefetch
                                          >
                                            {sub?.title}{' '}
                                            <ChevronRightIcon w={6} h={6} />
                                          </Link>
                                        </Text>
                                        <LazyLoadImageComponent
                                          src={sub?.icon?.url}
                                          alt={sub.title}
                                          height="auto"
                                          width="100%"
                                        />
                                      </Box>
                                      <Box
                                        maxH="50%"
                                        overflow="hidden"
                                        pt="16px"
                                      >
                                        {menuLoaded &&
                                          sub.submenuItems?.map(
                                            (subMenu, key2) => {
                                              if (key2 > 4) {
                                                return null;
                                              }
                                              return (
                                                <Link
                                                  href={refineUrlDomain(
                                                    subMenu?.url
                                                  )}
                                                  key={key2}
                                                  fontSize="1rem"
                                                  color="#FEFAF6"
                                                  fontFamily="var(--FedraSansStd-book)"
                                                  _focus={{
                                                    boxShadow: 'none',
                                                  }}
                                                  noOfLines="3"
                                                  display="flex"
                                                  justifyContent="space-between"
                                                  w="100%"
                                                  // prefetch
                                                >
                                                  <Box
                                                    as="span"
                                                    w={
                                                      subMenu?.icon
                                                        ? '85%'
                                                        : '100%'
                                                    }
                                                  >
                                                    {subMenu.title}
                                                  </Box>
                                                  {subMenu?.icon && (
                                                    <Box as="span" w="10%">
                                                      <LazyLoadImageComponent
                                                        w="20px"
                                                        src={subMenu?.icon}
                                                      />
                                                    </Box>
                                                  )}
                                                </Link>
                                              );
                                            }
                                          )}
                                        {sub.submenuItems.length < 1 && (
                                          <StructuredTextParser
                                            p="0"
                                            mt="0"
                                            str={render(sub.body)}
                                            fontFamily="var(--FedraSansStd-book)"
                                            color="#fff7e9"
                                          />
                                        )}
                                      </Box>

                                      {menu.key === 'productions' &&
                                      sub.submenuItems.length > 0 ? (
                                        <Box
                                          // marginTop="-10px"
                                          pos="absolute"
                                          // bottom="-10px"
                                          left="0"
                                          zIndex="1000"
                                          width="100%"
                                          background="#010509"
                                          h="30px"
                                        >
                                          <Link
                                            href={refineUrlDomain(sub?.url)}
                                            fontSize="1rem"
                                            color="#60ADFF"
                                            fontFamily="var(--FedraSansStd-book)"
                                            _focus={{ boxShadow: 'none' }}
                                            noOfLines="3"
                                            prefetch
                                          >
                                            View All
                                          </Link>
                                        </Box>
                                      ) : (
                                        ''
                                      )}
                                    </Box>
                                  </SimpleGrid>
                                </List>
                              );
                            })}
                          </Flex>
                        </Box>
                      </Box>
                    </li>
                  );
                } else {
                  return (
                    <li>
                      <Text
                        fontSize="1rem"
                        fontFamily="var(--FedraSansStd-medium)"
                        textTransform="uppercase"
                        color="#FEFAF6"
                      >
                        <Link
                          href={refineUrlDomain(menu?.url)}
                          _focus={{ boxShadow: 'none' }}
                          prefetch
                        >
                          {menu.title}
                        </Link>
                      </Text>
                    </li>
                  );
                }
              })}
            </ul>
          </nav>
        </Show>
        <Box display="flex" cursor="pointer" gap="2rem" alignItems="center">
          <Box className="search-wrap" display="flex">
            <form
              method="get"
              title="Search Form"
              action="/project-samskriti/search"
            >
              <Input
                className={activeInput && 'active-input'}
                ref={ref}
                variant="unstyled"
                pl="5px"
                placeholder="Search..."
                onKeyDown={e => {
                  if (e.code == 'Enter' || e.code.indexOf('Go') > -1) {
                    goToSearch();
                  }
                }}
                onChange={e => setInputValue(e.target.value)}
                _placeholder={{
                  color: '#333333',
                }}
                type="search"
                id="q"
                name="q"
              />
            </form>
            {!activeInput ? (
              <Icon
                width="24px"
                height="24px"
                viewBox="0 0 24px 24px"
                fill="none"
                className="searchIcon"
                onClick={() => setActiveInput(true)}
              >
                <path
                  d="M20 20L16.05 16.05M18 11C18 14.866 14.866 18 11 18C7.13401 18 4 14.866 4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11Z"
                  stroke="#fff"
                  stroke-width="2"
                  strokeLinecap="square"
                />
              </Icon>
            ) : (
              <Box>
                <Show above="lg">
                  <Icon
                    width="24px"
                    height="24px"
                    viewBox="0 0 24px 24px"
                    fill="none"
                    className="searchIcon"
                    onClick={() => setActiveInput(false)}
                  >
                    <path
                      d="M5 5L19 19M19 5L5 19"
                      stroke="#FEFAF6"
                      stroke-width="2"
                      strokeLinecap="square"
                    />
                  </Icon>
                </Show>
                <Show below="lg">
                  {inputValue && (
                    <Icon
                      width="24px"
                      height="24px"
                      viewBox="0 0 24px 24px"
                      fill="none"
                      className="searchIcon"
                      onClick={goToSearch}
                    >
                      <path
                        d="M13.5 5L20.5 12L13.5 19M3.5 12L20 12"
                        stroke="#FEFAF6"
                        stroke-width="2"
                      />
                    </Icon>
                  )}
                  {!inputValue && (
                    <Icon
                      width="24px"
                      height="24px"
                      viewBox="0 0 24px 24px"
                      fill="none"
                      className="searchIcon"
                      onClick={() => setActiveInput(false)}
                    >
                      <path
                        d="M5 5L19 19M19 5L5 19"
                        stroke="#FEFAF6"
                        stroke-width="2"
                        strokeLinecap="square"
                      />
                    </Icon>
                  )}
                </Show>
              </Box>
            )}
          </Box>

          <Show below="lg">
            <Box py={{ base: '15px', md: '22px' }}>
              {!showPrograms && (
                <HamburgerIcon
                  colorScheme="transparent"
                  border="0px solid"
                  aria-label="opens drawer"
                  px="0"
                  width={'28px'}
                  height="100%"
                  color="#FFFFFF"
                  _hover={{
                    boxShadow: 'none',
                    color: '#E19502',
                  }}
                  _focus={{
                    boxShadow: 'none',
                  }}
                  onClick={() => setShowPrograms(true)}
                />
              )}
              {showPrograms && (
                <Icon
                  width="24px"
                  height="24px"
                  viewBox="0 0 24px 24px"
                  fill="none"
                  onClick={() => {
                    setShowPrograms(false);
                    setMIndex(-1);
                  }}
                >
                  <path
                    d="M5 5L19 19M19 5L5 19"
                    stroke="#FEFAF6"
                    stroke-width="2"
                    strokeLinecap="square"
                  />
                </Icon>
              )}
            </Box>
          </Show>
          <Show above="lg">
            <Box
              borderRadius="100%"
              bg="white"
              p="0.5rem"
              pos="relative"
              zIndex="9999"
            >
              <Link
                href={refineUrlDomain(calender?.url)}
                flex="1"
                display="flex"
                textDecor="none"
                _hover={{ textDecor: 'none' }}
                _focus={{ boxShadow: 'none' }}
                prefetch
              >
                <Icon
                  width="24px"
                  height="24px"
                  viewBox="0 0 24px 24px"
                  fill="none"
                  cursor="pointer"
                >
                  <path
                    d="M4 10H20M8 5V3M16 5V3M4 5H20V20H4V5Z"
                    stroke="#000"
                    stroke-width="2"
                    strokeLinecap="square"
                  />
                </Icon>{' '}
              </Link>
            </Box>
          </Show>
        </Box>
        <Show below="lg">
          {showPrograms && (
            <Portal>
              <Box
                pos="fixed"
                top={{ base: '90px', md: '114px' }}
                height={{
                  base: 'calc(100vh - 90px)',
                  md: 'calc(100vh - 114px)',
                }}
                left="0"
                width="100%"
                bg="#010509"
                zIndex="1000"
                paddingBottom={{ base: '15%', md: '0' }}
                px="5%"
                borderTop="1px solid"
              >
                <Box
                  as="nav"
                  maxH="100%"
                  overflowY="auto"
                  w="100%"
                  pos="relative"
                  height="100%"
                >
                  {mIndex === -1 && (
                    <List
                      className="container ul-reset"
                      display="flex"
                      flexDir="column"
                      height="100%"
                      py="8px"
                    >
                      {headerData.map((menu, index) => {
                        if (
                          menu.key === 'logo' ||
                          menu.key === 'search' ||
                          menu.key === 'calender' ||
                          menu.key === 'hollow-btn'
                        ) {
                          return null;
                        } else if (menu.submenuItems.length > 0) {
                          return (
                            <ListItem p="0" key={index}>
                              <HStack
                                py="8px"
                                onClick={() => {
                                  setMIndex(index);
                                }}
                                cursor="pointer"
                              >
                                <LazyLoadImageComponent
                                  minW="92px"
                                  src={menu?.icon?.url}
                                  maxHeight="56px"
                                />
                                <Text
                                  color="#60ADFF"
                                  fontFamily="var(--FedraSansStd-medium)"
                                  fontFeatureSettings="'case' on"
                                  fontSize="1rem"
                                  fontStyle="normal"
                                  lineHeight="160%"
                                  letterSpacing="0.32px"
                                >
                                  {menu.title}
                                </Text>
                              </HStack>
                            </ListItem>
                          );
                        } else {
                          return (
                            <ListItem
                              p="0"
                              key={index}
                              _hover={{ boxShadow: 'none' }}
                              _focus={{ boxShadow: 'none' }}
                            >
                              {/* <LazyLoadImageComponent
                                minW="92px"
                                src={menu?.icon?.url}
                                maxHeight="56px"
                              /> */}
                              <Link
                                href={refineUrlDomain(menu.url)}
                                _hover={{
                                  boxShadow: 'none',
                                  borderWidth: 0,
                                  borderColor: 'none',
                                }}
                                _focus={{
                                  boxShadow: 'none',
                                  borderWidth: 0,
                                  borderColor: 'none',
                                }}
                                borderColor="none"
                                borderWidth="0"
                                p="0"
                                prefetch
                              >
                                <HStack py="8px" cursor="pointer">
                                  {menu?.icon?.url && (
                                    <LazyLoadImageComponent
                                      minW="92px"
                                      display="inline"
                                      src={menu?.icon?.url}
                                      maxHeight="56px"
                                    />
                                  )}
                                  <Text
                                    color={
                                      menu?.icon?.url ? '#60ADFF' : '#FEFAF6'
                                    }
                                    fontFamily={
                                      menu?.icon?.url
                                        ? 'var(--FedraSansStd-medium)'
                                        : 'var(--FedraSansStd-book)'
                                    }
                                    fontSize="1rem"
                                    fontStyle="normal"
                                    lineHeight="160%"
                                    letterSpacing="0.32px"
                                  >
                                    {menu?.title}
                                  </Text>
                                </HStack>
                              </Link>
                            </ListItem>
                          );
                        }
                      })}
                      <ListItem p="0">
                        <HStack py="8px" h="50px">
                          <Text
                            fontFamily="var(--FedraSansStd-book)"
                            fontSize="1rem"
                            fontStyle="normal"
                            color="#FEFAF6"
                            lineHeight="160%"
                            letterSpacing="0.32px"
                          ></Text>
                        </HStack>
                      </ListItem>
                      <ListItem
                        p="0"
                        borderTop="1px solid #0E1216"
                        w="100%"
                        pos="absolute"
                        bottom="0"
                      >
                        <HStack py="20px" justifyContent="stretch" w="100%">
                          <Link
                            href={refineUrlDomain(calender?.url)}
                            flex="1"
                            display="flex"
                            textDecor="none"
                            _hover={{ textDecor: 'none' }}
                            _focus={{ boxShadow: 'none' }}
                            prefetch
                          >
                            <Button
                              w="100%"
                              fontWeight="normal"
                              color="#60ADFF"
                              fontFamily="var(--FedraSansStd-medium)"
                              bg="rgba(96, 173, 255, 0.10)"
                              border="0px solid"
                              h={50}
                              rounded={0}
                              leftIcon={<GoCalendar size={24} />}
                              _hover={{
                                background: '#80BDFF',
                                border: 'none',
                                color: '#010509',
                              }}
                              _focus={{ boxShadow: 'none' }}
                            >
                              {calender.title}
                            </Button>
                          </Link>
                          <Link
                            href={refineUrlDomain(engage.url)}
                            flex="1"
                            display="flex"
                            textDecor="none"
                            _hover={{ textDecor: 'none' }}
                            prefetch
                            _focus={{ boxShadow: 'none' }}
                          >
                            <Button
                              w="100%"
                              fontWeight="normal"
                              color="#60ADFF"
                              fontFamily="var(--FedraSansStd-medium)"
                              bg="rgba(96, 173, 255, 0.10)"
                              border="0px solid"
                              h={50}
                              rounded={0}
                              _hover={{
                                background: '#80BDFF',
                                border: 'none',
                                color: '#010509',
                              }}
                              _focus={{ boxShadow: 'none' }}
                              leftIcon={<FaRegCheckCircle size={24} />}
                            >
                              {engage.title}
                            </Button>
                          </Link>
                        </HStack>
                      </ListItem>
                    </List>
                  )}
                  {mIndex > -1 && (
                    <List>
                      <MobMenu
                        mIndex={mIndex}
                        title="PRODUCTIONS"
                        setMIndex={setMIndex}
                        headerData={headerData}
                      />
                    </List>
                  )}
                </Box>
              </Box>
            </Portal>
          )}
        </Show>
      </Box>
      <style global jsx>
        {`
          .search-wrap {
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all 0.5s;
            width: 0;
            height: 42px;
            box-sizing: border-box;
            margin-right: 60px;
            z-index: 100;
          }
          .search-wrap input {
            position: absolute;
            top: 1.5rem;
            width: 100%;
            height: 2.5rem;
            right: 0;
            line-height: 30px;
            outline: 0;
            border: 0;
            display: none;
            font-size: 1em;
            border-radius: 20px;
            padding: 0 20px;
            font-family: 'var(--FedraSansStd-medium)';
            background: #090d11;
            color: #fff;
          }
          .search-wrap .searchIcon {
            position: absolute;
            top: 2rem;
            right: 0;
          }
          .search-wrap:hover {
            cursor: pointer;
          }

          .search-wrap .active-input {
            display: block;
            width: 65vw;
            right: 0;
          }
          @media (max-width: 768px) {
            .search-wrap .active-input {
              display: block;
              width: 75vw;
              right: 0;
            }
          }
          .container {
            margin: 60px auto;
          }
          .ul-reset {
            padding-left: 0;
            margin-top: 0;
            margin-bottom: 0;
            list-style: none;
          }

          nav {
            font-size: 0;
          }
          nav > ul > li {
            display: inline-block;
            font-size: 14px;
            padding: 0 15px;
            position: relative;
          }
          nav > ul > li:first-child {
            padding-left: 0;
          }
          nav > ul > li:last-child {
            padding-right: 0;
          }
          nav > ul > li > a {
            color: #fff;
            display: block;

            position: relative;
            padding: 20px 0;
            border-bottom: 3px solid transparent;
          }
          nav > ul > li:hover > a {
            color: #fff;

            border-bottom: 3px solid #69aae0;
          }

          .mega-menu {
            background: #000;
            display: none;
            left: 0;
            position: absolute;
            text-align: left;
            width: 100%;
            z-index: 9000;
          }

          .mega-menu ul {
            float: left;
            margin-bottom: 20px;
            margin-right: 40px;
            width: 205px;
          }
          .mega-menu ul:last-child {
            margin-right: 0;
          }

          .droppable {
            position: static;
          }
          .droppable > a:after {
            font-size: 12px;
            padding-left: 6px;
            position: relative;
            top: -1px;
          }
          #ps-header {
            transition: all 0.2s linear;
            background: ${isMegaMenu > -1 || showPrograms
              ? '#010509'
              : theme === 'light'
              ? 'rgba(0, 0, 0, 0.30)'
              : '#010509'};
          }
          .droppable:hover .mega-menu {
            display: ${isPathChanged ? 'none' : 'block'};
            background-color: #010509;
            transition: all 0.4s linear;
            color: red;
          }
          .cf:before,
          .cf:after {
            content: ' ';
            display: table;
          }
          .cf:after {
            clear: both;
          }
        `}
      </style>
    </Box>
  ) : (
    ''
  );
};

export default Header;
